@import 'styles/variables';
@import 'styles/mixins';

.headerContainer {
  height: 72px;
  border-radius: 8px 8px 0 0;
  border-bottom-color: $grey-10;
  position: sticky;
  top: -48px;
  z-index: 2;

  [data-autopilot-system-redesign='on'] & {
    position: relative;
    top: 0;
  }
}

.table {
  min-width: 800px;
}

.header {
  height: 72px;
  background-color: transparent !important;
  justify-content: center;
  border-right: none;
}

.headerLabel {
  color: $black;
  font-size: 14px;
  display: inline-block;
  margin-top: 8px;
}

.checkboxLabel {
  font-size: 14px;
  color: $black;
}

.row {
  border-bottom-color: $grey-10;
  padding-bottom: 0 !important;
  padding-top: 0 !important;
}

.cell {
  padding-bottom: 0;
  padding-top: 0;
  margin-bottom: auto;
  margin-top: auto;
  p {
    margin-bottom: 0;
  }
}

.cellHidden {
  visibility: hidden;
}

.checkbox {
  margin: 0 auto;
  justify-content: center;
}

.labelCell {
  margin-top: auto;
  padding-top: 27px;
  padding-bottom: 27px;
  padding-left: 0;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

@include for-phone-only {
  .row {
    flex-direction: column;
  }

  .labelCell {
    padding-top: 14px;
    padding-bottom: 14px;
  }

  .cell {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0;

    &:first-child {
      min-width: 118px;
    }

    .checkbox {
      margin: 0;
    }
  }

  .header {
    padding: 0;

    span {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 8px;
    }
  }

  .headerContainer {
    width: 100%;
    display: flex;
    gap: 20px;
    top: -16px;
    background-color: $white;
  }

  .headerLabel {
    margin: 0;
  }

  .checkboxes {
    display: flex;
    width: 100%;
    gap: 20px;
    padding-bottom: 14px;

    .cell {
      padding: 0;
    }
  }
}
